module.exports = __webpack_public_path__ + "static/media/logoXherlight.3e9743dc.svg";